<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <br><br><br><br><br>
  <main class="mt-0 main-content">
    <section>
    
    <div class="py-4 container-fluid">

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-12">
              <card
                title="Submitted (last 30 days)"
                :value="metrics[0].Submitted"
                percentage=""
                iconClass=""
                iconBackground=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <card
                title="MAPDs (YTD)"
                :value="metrics[0].MAPDs"
                percentage=""
                iconClass=""
                iconBackground=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <card
                title="Not at Carrier Level (YTD)"
                :value="metrics[0].NACL"
                percentage=""
                iconClass=""
                iconBackground=""
                percentageColor=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <card
                title="Lost (YTD)"
                :value="metrics[0].Lost"
                percentage=""
                iconClass=""
                iconBackground=""
                hint=""
                directionReverse
              ></card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-7 mb-lg">
              <!-- line chart -->
              <div class="card z-index-2">
                <gradient-line-chart />
              </div>
            </div>
            <div class="col-lg-5">
              <carousel />
            </div>
          </div>
          <div v-if="(this.company =='Aspire' && !isAgent) || this.company != 'Aspire'" class="row mt-4">
            <div class="col-lg-7 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Top selling agents YTD</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr v-for="(sale, index) in sales" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div>
                              <img :src="sale.flag" alt="Country flag" />
                            </div>
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Agent:</p>
                              <h6 class="mb-0 text-sm">{{ sale.agent }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Enrollments:</p>
                            <h6 class="mb-0 text-sm">{{ sale.enrollments }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">MAPD's:</p>
                            <h6 class="mb-0 text-sm">{{ sale.mapds }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center" hidden>
                            <p hidden class="mb-0 text-xs font-weight-bold">Value:</p>
                            <h6 hidden class="mb-0 text-sm">{{ "$" + sale.value }}</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-lg-5">

              <div class="col-lg-10 mb-lg-0 mb-4" v-if="!isAgent">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Onboarding queue</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">                            
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Contracting:</p>
                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'contracting'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"
                                >
                                <h6 class="mb-0 text-sm">{{ onboarding[0].Contracting }} - Average days in bucket: {{ onboarding[0].Contracting_age }}</h6>
                                </a> 
                              </router-link>
                            </div>
                          </div>
                        </td>                     
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Operations:</p>
                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'operations'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                              <h6 class="mb-0 text-sm">{{ onboarding[0].Operations }} - Average days in bucket: {{ onboarding[0].Operations_age }}</h6>
                              </a>
                              </router-link>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Training:</p>
                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'training'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                                <h6 class="mb-0 text-sm">{{ onboarding[0].Training }} - Average days in bucket: {{ onboarding[0].Training_age }}</h6>
                                </a>
                              </router-link>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Compliance:</p>
                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'compliance'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                                <h6 class="mb-0 text-sm">{{ onboarding[0].Compliance }} - Average days in bucket: {{ onboarding[0].Compliance_age }}</h6>
                                </a>
                              </router-link>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Agency:</p>

                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'agency'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                                <h6 class="mb-0 text-sm">{{ onboarding[0].Agency }} - Average days in bucket: {{ onboarding[0].Agency_age }}</h6>
                                </a>
                              </router-link>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">RTS:</p>
                              
                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'rts'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                                <h6 class="mb-0 text-sm">{{ onboarding[0].RTS }} - Average days in bucket: {{ onboarding[0].RTS_age }}</h6>
                                </a>
                              </router-link>

                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Selling:</p>
                              <h6 class="mb-0 text-sm">{{ onboarding[0].Selling }}</h6>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">No Sales:</p>

                              <router-link v-if="!isAgent" :to="{ name: 'AgentSubset', params: {type: 'no_sales'}}" class="font-weight-bold">
                                <a
                                href="#"
                                class="text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"                   
                                > 
                                <h6 class="mb-0 text-sm">{{ onboarding[0].No_Sales }}</h6> 
                                </a>
                              </router-link>
                              
                            </div>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </div>

            <div class="col-lg-5">
              <br>
            <div class="col-lg-10 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Enrollments Today - {{ this.todays_totals }}</h6>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(sale, index) in sales_today" :key="index">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <img :src="sale.flag" alt="Country flag" hidden/>
                          </div>
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Agent:</p>
                            <h6 class="mb-0 text-sm">{{ sale.agent }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Enrollments:</p>
                          <h6 class="mb-0 text-sm">{{ sale.enrollments }}</h6>
                        </div>
                      </td>

                      <td>
                        <div class="text-center" hidden>
                          <p hidden class="mb-0 text-xs font-weight-bold">Value:</p>
                          <h6 hidden class="mb-0 text-sm">{{ "$" + sale.value }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </div>
            </div>

            <div class="col-lg-5">
              <br>
              
              <div class="col-lg-10 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Enrollments (This AEP) - {{ this.aep_total }}</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr v-for="(sale, index) in sales_aep" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Date:</p>
                              <h6 class="mb-0 text-sm">{{ new Date(sale.date).toLocaleDateString() }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Enrollments:</p>
                            <h6 class="mb-0 text-sm">{{ sale.enrollments }}</h6>
                          </div>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    </section>
  </main>

</template>

<script>

import Navbar from "@/examples/PageLayout/NavbarLoggedin.vue";

import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
//import CategoriesCard from "./components/CategoriesCard.vue";

const company = sessionStorage.getItem("company");

export default {
  name: "dashboard",
  data() {
    return {
      metrics: [{ 
        'metric1': 0,
        'metric2': 0,
        'metric3': 0,
        'metric4': 0
    }],
    company: '',
    sales: [],
    sales_today: [],
    sales_aep: [],
    aep_total: 0,
    todays_totals: 0,
    onboarding: [{ 
        'Contracting': 0,
        'Contracting_age': 0,
        'Operations': 0,
        'Operations_age': 0,
        'Training': 0,
        'Training_age': 0,
        'Compliance': 0,
        'Compliance_age': 0,
        'Agency': 0,
        'Agency_age': 0,
        'RTS': 0,
        'RTS_age': 0
    }],
    role: sessionStorage.getItem('role')
    };
  },
  computed: {
    isFYMAdmin() {
      return this.role === 'FYM Admin';
    },
    isAgencyAdmin() {
      return this.role === 'Agency Admin';
    },
    isAgentManager() {
      return this.role === 'Agent Manager';
    },
    isAgent() {
      return this.role === 'Agent';
    }
  },
  methods: {
    async getData() {
        let response = await fetch("/apis/metrics");
        this.metrics = await response.json();
    },
    async getData2() {
        let response = await fetch("/apis/sales");
        this.sales = await response.json();
    },
    async getData3() {
        let response = await fetch("/apis/sales_today");
        this.sales_today = await response.json();
    },
    async getData4() {
        let response = await fetch("/apis/todays_totals");
        this.todays_totals = await response.json();
    },
    async getData5() {
        let response = await fetch("/apis/sales_aep");
        this.sales_aep = await response.json();
    },
    async getData6() {
        let response = await fetch("/apis/onboarding");
        this.onboarding = await response.json();
    },
    async getData7() {
        let response = await fetch("/apis/sales_aep_total");
        let data = await response.json();
        this.aep_total = data;
    },
  },
  components: {
    Navbar,
    Card,
    GradientLineChart,
    Carousel
  },
  created() {
    this.company = sessionStorage.getItem("company");
    this.getData();
    this.getData2();
    this.getData3();
    this.getData4();
    this.getData5();
    this.getData6();
    this.getData7();
  },
};
</script>
